import * as React from "react";

import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import type { SxProps } from "@mui/material/styles";

import AssignedTagsList from "components/assigned-tags";
import { TagTypes } from "constants/tags";
import { type AssignedTag } from "services/types/assigned-tag.type";
import { type Tag } from "services/types/tags.type";

type AssignedAppointmentTagsFieldProps = {
  onDelete?: (tag_id: number, index?: number) => void;
  onAdd?: (tag_id: number, tag: Tag) => void;
  onUpdate?: (tag: AssignedTag) => void;
  tags?: AssignedTag[];
  sx?: SxProps;
};

export default function AssignedAppointmentTagsField({
  tags,
  sx,
  onDelete,
  onAdd,
  onUpdate
}: AssignedAppointmentTagsFieldProps) {
  return (
    <Stack ml={2} sx={sx}>
      <Typography
        mb={1}
        sx={{
          fontSize: "0.875rem",
          letterSpacing: "0.7px",
          lineHeight: "1.4375em",
          fontWeight: 700,
          textTransform: "uppercase"
        }}
      >
        Appointment Tags
      </Typography>
      <AssignedTagsList
        sx={{ mb: -1, ...sx }}
        tagType={TagTypes.APPOINTMENT}
        tags={tags || []}
        disableUpdateMutation
        onAdd={onAdd}
        onDelete={onDelete}
        onUpdate={onUpdate}
      />
    </Stack>
  );
}
